import { useEffect, useRef, useState } from 'react';
import Card from './Card';
import SupportTabs from './SupportTabs';
import styles from './index.module.css';
import { TRegistration, TServiceCharge } from '../../types';
import StatusTable from '../Status/StatusTable';
import useWindowDimensions from '../../hooks/useWindowDimension';
import StatusHeader from '../Status/StatusHeader';
import StatusFilter from '../Status/StatusFilter';
import { wqkgx } from '../../config/keys';
import CryptoJS from 'crypto-js';
import CustomBusinessSupport from '../CustomBusinessSupport';
import { hasARegistrationInLocalStorage } from '../../utils/setRegInfoInLocalStorage';
import { getModiefiedRegistrations } from '../../utils/statusTableFns';
import { ClipLoader } from 'react-spinners';

type TProps = {
  packages: TServiceCharge[];
  registrations: TRegistration[];
  selectedTab: number;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  loadingRegistrations: boolean;
};
const SupportSection = ({
  packages,
  registrations,
  selectedTab,
  setSelectedTab,
  loadingRegistrations,
}: TProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(-2);
  const ref: any = useRef(null);
  const { width } = useWindowDimensions();
  const [divWidth, setDivWidth] = useState(ref?.current?.clientWidth);
  const [sortBy, setSortBy] = useState('createdAt');
  const [search, setSearch] = useState('');

  useEffect(() => {
    setDivWidth(ref.current.clientWidth);
  }, [width]);

  const registrationsInStorage = hasARegistrationInLocalStorage();
  const modifiedRegInStorage = getModiefiedRegistrations(registrationsInStorage);
  const totalRegistrations = [...registrations, ...modifiedRegInStorage];
  return (
    <div
      ref={ref}
      className='text-xs sm:text-sm md:text-base py-[24px] sl:min-w-[80%] sl:p-[2rem] sl:ml-[250px]'
    >
      <SupportTabs
        tabs={['Basic Business Support', 'Custom Business Support', 'View Status']}
        setSelected={setSelectedTab}
        selected={selectedTab}
      />

      <div className={styles.cardDiv}>
        {selectedTab === 0 ? (
          packages
            // ?.sort((a, b) => (a.price ?? 0) - (b?.price ?? 0))
            .map((option, index) => (
              <Card
                items={option.items}
                price={option?.price?.toString()}
                selected={selectedIndex === index ? true : false}
                subtitle={option.subTitle}
                title={option.title}
                key={option?.id}
                packkage={option}
                handleClick={() => {
                  setSelectedIndex(index);
                  localStorage.setItem('package-price', option?.price?.toString() ?? '');
                  localStorage.setItem(
                    'package-id',
                    CryptoJS.AES.encrypt(JSON.stringify(option.id), wqkgx).toString(),
                  );
                  localStorage.setItem(
                    'package',
                    CryptoJS.AES.encrypt(JSON.stringify(option.title), wqkgx).toString(),
                  );
                }}
              />
            ))
        ) : selectedTab === 1 ? (
          <CustomBusinessSupport />
        ) : (
          <div className='w-full'>
            {loadingRegistrations ? (
              <div className='flex justify-center w-full'>
                <ClipLoader size={'40px'} />
              </div>
            ) : totalRegistrations?.length === 0 ? (
              <div className='text-[14px] text-[black] font-[500]'>
                You have not started any registration yet.
              </div>
            ) : (
              <>
                <StatusHeader />
                <StatusFilter setSortBy={setSortBy} setSearch={setSearch} />
                <StatusTable
                  divWidth={divWidth}
                  registrations={totalRegistrations}
                  sortBy={sortBy}
                  search={search}
                />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportSection;
